import React from 'react';
import PenIcon from '../Icons/solid/PenIcon';
import { COLORS } from '../../config';

import Select from 'react-select'

function FieldWithSelectEdit({
  edit,
  data,
  onChange,
  label,
  options,
  props,
}) {

   
  const selectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'white' : '#1a3b5c',
        backgroundColor: state.isSelected ? '#006bb7' : '',
        ':hover': {
          backgroundColor: state.isSelected ? '#006bb7' : '#006bb725',
        }
    }),
    control: (provided, state) => ({
      ...provided,
      outline: state.isFocused ? '0px solid red' : '',
      outlineOffset: state.isFocused ? '16px' : '8px',
      borderRadius: '0.25rem',
      fontSize: '0.85rem',
      lineHeight: 1,
      borderStyle: 'none',
      boxShadow: 'none',
      margin: '0px',
    }),
    placeholder: () => ({
      color: '#9ea4b0'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0px',
      margin: '0px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#9ca4ae',
      fontSize: '16px',
      lineHeight: '1.25',
      margin: '0px',
    }),

  };

  return (
    <div className='flex border-b-2 border-gray-100 pb-2'>
      <span className="uppercase font-bold text-secondary w-36">{label}</span>
      {!edit && 
      <div className='flex justify-between items-center flex-grow pl-12 p-1'>
        <span className="text-gray-600">{ data }</span>
      </div>
      }
      {edit && 
      <div className='flex justify-between items-center flex-grow pl-12'>
        <Select options={options} className="w-full md:w-72" styles={selectStyles} value={ { label: data } } onChange={onChange} { ...props } />
        <PenIcon fill={COLORS.colorSecondary} className='mr-3'/>
      </div>
      }
    </div>
  )
}

export default FieldWithSelectEdit
